import { Component } from '@angular/core';

@Component({
  selector: 'mtm-list-view-icon',
  templateUrl: './list-view-icon.component.html',
  styles: [],
  standalone: false,
})
export class ListViewIconComponent {}
